module.exports = __webpack_public_path__ + "static/media/indosat-lp-hero.35c3bbcc.svg";